import { signal } from "@preact/signals-react";
import { getStorage } from "../helpers/helper";

export const currentLanguage = signal(
  getStorage("newProLang")[0] ? getStorage("newProLang")[0] : "en"
);
export const fristLogin = signal(getStorage("newProLang")[0] ? 0 : 1);
export const LanguageDirection = signal(
  getStorage("newProLang")[1] ? getStorage("newProLang")[1] : "ltr"
);
export const OffcanvasPlacement = signal(
  getStorage("newProLang")[2] ? getStorage("newProLang")[2] : "end"
);
export const OffcanvasClass = signal(
  getStorage("newProLang")[3]
    ? getStorage("newProLang")[3]
    : "OffcanvasList rounded-end-4"
);

// Language dictionary
const languageDictionary = {
  ar: {
    More: "المزيد",
    LanguageTitle: "اللغة",
    Language: "عربي",
    AppColor: "لون التطبيق",
    Logout: "تسجيل الخروج",
    loginAccount: "تسجيل الدخول",
    loginPara: "اكتشف عالم الأقمشة",
    ClientCode: "كود العميل",
    MobileNumber: "رقم الجوال",
    Password: "كلمة السر",
    Login: "تسجيل الدخول",
    Loading: "جار التحميل",
    ErrorClientCode: "يرجى إدخال رقم يتكون من 9 او 10 أرقام صالح.",
    ErrorMobileNumber: "يرجى إدخال رقم هاتف محمول يتكون من 10 أرقام صالح.",
    ErrorPassword: "يرجى إدخال كلمة مرور تحتوي على 9 أحرف على الأقل.",

    verifyPhone: "تحقق من الهاتف",
    verifyText: "تم إرسال الرمز إلى",
    verifyResent: "لم تستلم الرمز؟",
    verifyResentbtn: "اطلب مرة أخرى",
    Verify: "تحقق",

    HomeTitle: "الرئيسية",
    Morning: "صباح الخير",
    Hello: "مرحبا",
    daysOfWeek: [
      "الأحد",
      "الاثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "الجمعة",
      "السبت",
    ],
    Goles: "هدفك",
    intarget: "مشترياتي",
    outtargit: "مشترياتي بتخفيض مرتفع",
    latePay: "دفعات متأخره",
    Currency: "ريال",
  CurrencyKuwaitShort: "د.ك",
  CurrencyQatarShort: "ر.ق",
  CurrencyBahrainShort: "د.ب",
  CurrencyLebanonShort: "$",
  CurrencyYemenShort: "ر.ي",
  CurrencyOmanShort: "ر.ع",
  CurrencyJordanShort: "د.ا",
    Invoices: "الفواتير",
    LATEPRO: "عقود متاخرة الاستلام",
    Returns: "المرتجعات",

    OrderTitle: "طلب",
    MyOrderTitle: "طلباتي",
    SearchTitle: "رقم العقد / الفاتورة",
    Search: " بحث ",
    LastOrders: "اخر 10 طلبات",
    ContractNumber: "رقم العقد",
    OrderDate: "تاريخ الطلب",
    Tracking: "تتبع",
    Ordered: "تم إستلام الطلب",
    Prepared: "تم القص",
    Shipped: "تم الشحن",
    Delivered: "مستلم",
    DeliveredDate: "تاريخ التسليم",
    orderItems: "تفاصيل الطلب",
    No: "الرقم",
    CancelOrder: "لإلغاء الطلب تواصل مع مركز الاتصال.",

    ProductTitle: "المنتجات",
    Product: "منتج",
    Catalog: "كتلوج",
    QRcode: "كود QR",
    ProductCode: "كود المنتج",
    CatalogNumber: "رقم الكتلوج",
    Serial: "التسلسل",
    Quantity: "الكمية",
    Type: "النوع",
    Upholstery: "تنجيد",
    Curtains: "ستائر",
    Cushion: "وسائد",
    AllWhs: "ابحث في جميع المستودعات",
    State: "الحالة",
    OnePiece: "قطع واحدة",
    SeveralPiece: "عدة قطع",
    SmallerPiece: "حجم أصغر قطعة",

    SizeOfEach: "حجم كل قطعه",
    Price: " السعر (بضريبة القيمة المضافة):",
    Composition: "القماش:",
    Width: "العرض:",
    Weight: "الوزن:",
    PatternRepeat: " نمط التكرر:",
    Country: "البلد:",
    Repository: "المخزن:",
    addToCart: "اضافة الى السلة",
    ItemNotFound: "المنتج غير متوفر",
    Wasalat: "قد يحتوي الطلب على اوصال",
    otherItem: "منتجات أخرى من المجموعة",

    Thank: "شكراً!",
    ThankBady: "شكراً لاختيارك القثمي، رقم الطلب",

    Checkout: "الدفع",
    PaymentDetails: "تفاصيل الدفع",
    PaymentMethod: "طريقة الدفع",
    Cash: "نقداً",
    DebitCredit: "بطاقة خصم/ائتمان",
    OrderSummary: "ملخص الطلب",
    DeliveryFees: "رسوم التوصيل",

    CartTitle: "السلة",
    total: "الاجمالي بضريبة القيمة المضافة:",
    ConfirmOrder: "تأكيد الطلب",
    NoCartItem: "لا يوجد عنصر في السلة",

  OfferTitle: "العروض",
  ShowMore: "عرض المزيد",
  ValidTill: "ساري حتى :",
  VideoTagNotSupported: "متصفحك لا يدعم تشغيل الفيديو.",
  UnknownOfferType: "نوع العرض غير معروف",
  OfferAlt: "عرض",

    Coupon: "كوبون",
    coupNo: "رقم الكوبون",
    ExpiryDate: "تاريخ الانتهاء",
    invoiceValue: "من قيمة الفاتورة",

    SearchCatalogTitle: "رقم الكتلوج",
    Catalogs: "الكتلوجات",
    CatalogNo: "كتلوج رقم:",

    CouponList: "قائمة الكوبون",

    NoteRateTitle: "ملاحظات و تقيم",

    ProfileTitle: "حسابي",

    ContractDate: "تاريخ العقد",
    OrderNumber: "رقم الطلب",
    Send: "ارسال",
    Notes: "ملاحظات",
    Service: "الخدمة",
    Representative: "المندوب",
    ConfermPassword: "تأكيد كلمة السر",
    Save: "حفط",
    Balance: "الرصيد",

    Profile: "الملف الشخصي",
    email: "البريد الإلكتروني",
    representative: "اسم المندوب",
    representativeNo: "رقم هاتف المندوب",
    CustomerService: "خدمة العملاء",
    TermsAndConditions: "الشروط و الاحكام",
    
  // Login options
  RememberMe: "تذكرني",
    
    // Notification translations
    enableNotifications: "تفعيل الإشعارات",
    enableNotificationsDesc: "اسمح للتطبيق بإرسال إشعارات لتبقى على اطلاع بأحدث العروض والطلبات",
    allow: "السماح",
    later: "لاحقاً",
    notificationsEnabled: "تم تفعيل الإشعارات",
    notificationsEnabledDesc: "ستتلقى الآن إشعارات حول العروض الجديدة وحالة الطلبات",
    testNotification: "اختبار الإشعار",
    notificationTestSent: "تم إرسال إشعار اختبار",
    notificationPermissionDenied: "تم رفض إذن الإشعارات",
    notificationPermissionDefault: "لم يتم طلب إذن الإشعارات بعد",
    notificationPermissionGranted: "تم منح إذن الإشعارات",
    
    AboutUsTitle: "نبذه عنا",
    AboutUs:
      "نحن إرث من الأقمشة والأنسجة المتنوعة، وقد تمّ تصنيفنا في المرتبة الرابعة من بين أكبر شركات الأقمشة المدرجة للبيع بالجملة خارج أمريكا الشمالية (Fabrics & Furnishing International)، كما نرمز في الوقت ذاته إلى مزيج الجودة والإبداع والأسعار المناسبة.\n\nنحن ملتزمون بإثراء حياة عملائنا في متاجر التجزئة، والقصور، ومصانع الأثاث، والفنادق، والتصميم الداخلي، من خلال أرقى أنواع الأقمشة والأنسجة والإكسسوارات الرائعة، بالإضافة إلى عروضنا المخصصة وفقاً لاحتياجاتهم.\n\nيشكل التصميم والإبداع الأساس الذي بنيت عليه أعمالنا، حيث يعتبران مصدر إلهام وتمييز لدينا.\n\nنقوم باختيار وتنسيق مجموعتنا التي تتضمن أيضاً ستائر خارجية وستائر معتمة بالإضافة إلى منتجات الأطفال، مع التركيز على الجودة والامتياز وتلبية مختلف الأنماط والأذواق، من الفئات الراقية إلى الفئات القيّمة.\n\nتقدم شركتنا مجموعة واسعة من الأقمشة التي تضم مجالات متنوعة، بدءاً من الكلاسيكيات الخالدة وصولاً إلى التصاميم العصرية والمتطورة، من البساطة الراقية وحتى أعلى مستويات الموضة. ومن روح الابتكار هذه، نقدم أيضاً أقمشة معالجة متخصصة تشمل الخيارات سهلة التنظيف، والمناسبة للأطفال والحيوانات الأليفة، والأخرى المقاومة للاحتراق، بالإضافة إلى الأقمشة المتينة، والمقاومة للماء، والانسكاب، وللبقع والروائح، والخيارات المضادة للبكتيريا، مما يشكل قيمة إضافية لعروضنا.\n\nتطبيقنا مصمم لجعل عملية الطلب أسهل من أي وقت مضى. بنقرة واحدة فقط، يمكنك التصفح بالسرعة التي تناسبك، والدردشة معنا، وطرح الأسئلة، وإجراء طلبك. نحن دائماً نسعى لتحسين خدماتنا وتقديم أفضل تجربة ممكنة لك.\n\nاستمتع برحلتك معنا.",
  },

  en: {
    More: "More",
    LanguageTitle: "Language",
    Language: "English",
    AppColor: "App Color",
    Logout: "Logout",
    loginAccount: "Login Account",
    loginPara: "Discover the World of Fabrics",
    ClientCode: "Client Code",
    MobileNumber: "Mobile Number",
    Password: "Password",
    Login: "Login",
    Loading: "Loading",
    ErrorClientCode:
      "Please enter a valid number consisting of 9 or 10 digits.",
    ErrorMobileNumber: "Please enter a valid 10-digit mobile number.",
    ErrorPassword: "Please enter a password with at least 10 characters.",

    // Notification translations
    enableNotifications: "Enable Notifications",
    enableNotificationsDesc: "Allow the app to send notifications to stay updated on latest offers and orders",
    allow: "Allow",
    later: "Later",
    notificationsEnabled: "Notifications Enabled",
    notificationsEnabledDesc: "You will now receive notifications about new offers and order status",
    testNotification: "Test Notification",
    notificationTestSent: "Test notification sent",
    notificationPermissionDenied: "Notification permission denied",
    notificationPermissionDefault: "Notification permission not requested yet",
    notificationPermissionGranted: "Notification permission granted",

    verifyPhone: "Verify Phone",
    verifyText: "Code is sent to",
    verifyResent: "Didn't recive code?",
    verifyResentbtn: "Request again",
    Verify: "Verify",

    HomeTitle: "Home",
    Morning: "Good Morning",
    Hello: "Hello",
    daysOfWeek: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    Goles: "Target",
    intarget: "My Purchases",
    outtargit: "High Discount Purchases",
    latePay: "Late Payments",
    Currency: "Riyal",
  CurrencyKuwaitShort: "KWD",
  CurrencyQatarShort: "QAR",
  CurrencyBahrainShort: "BHD",
  CurrencyLebanonShort: "USD",
  CurrencyYemenShort: "YER",
  CurrencyOmanShort: "OMR",
  CurrencyJordanShort: "JOD",
    Invoices: "Invoices",
    LATEPRO: "Late Delivery Contracts",
    Returns: "Returns",

    OrderTitle: "Order",
    MyOrderTitle: "My Orders",
    SearchTitle: "Contract / Invoice Number",
    Search: "Search",
    LastOrders: "Last 10 Orders",
    ContractNumber: "Contract Number",
    OrderDate: "Order Date",
    Tracking: "Tracking",
    Ordered: "Ordered",
    Prepared: "Prepared",
    Shipped: "Shipped",
    Delivered: "Delivered",
    DeliveredDate: "Delivered Date",
    orderItems: "Order Detail",
    No: "No.",
    CancelOrder: "To cancel the order, contact the call center.",

    ProductTitle: "Products",
    Product: "Product",
    Catalog: "Catalog",
    QRcode: "QR Code",
    ProductCode: "Product Code",
    CatalogNumber: "Catalog Number",
    Serial: "Serial",
    Quantity: "Quantity",
    Type: "Type",
    Upholstery: "Upholstery",
    Curtains: "Curtains",
    Cushion: "Cushion",
    AllWhs: "Search by all warehouses",
    State: "State",
    OnePiece: "One Piece",
    SeveralPiece: "Several Pieces",
    SmallerPiece: "Smaller Piece Size",
    Wasalat: "The request may piece",
    otherItem: "Other products from the collection",

    Thank: "Thank You!",
    ThankBady: "Thank you for chosing Guthmi, Order number",

    Checkout: "Checkout",
    PaymentDetails: "Payment Details",
    PaymentMethod: "Payment method",
    Cash: "Cash",
    DebitCredit: "Debit/Credit Card",
    OrderSummary: "Order Summary",
    DeliveryFees: "Delivery Fees",

    SizeOfEach: "Size of Each Piece",
    Price: "Price (with Vat):",
    Composition: "Composition:",
    Width: "Width:",
    Weight: "Weight:",
    PatternRepeat: "Pattern Repeat:",
    Country: "Country:",
    Repository: "Repository:",
    addToCart: "Add to Cart",
    ItemNotFound: "Item not available",

    CartTitle: "Cart",
    total: "Total (with Vat):",
    ConfirmOrder: "Confirm Order",
    NoCartItem: "No Cart Item",

  OfferTitle: "Offers",
  ShowMore: "Show More",
  ValidTill: "Valid Till :",
  VideoTagNotSupported: "Your browser does not support the video tag.",
  UnknownOfferType: "Unknown Offer Type",
  OfferAlt: "Offer",

    Coupon: "Coupon",
    coupNo: "Coupon Number",
    ExpiryDate: "Expiry Date",
    invoiceValue: "from the invoice value",

    SearchCatalogTitle: "Catalog Number",
    Catalogs: "Catalogs",
    CatalogNo: "Catalog No.",

    CouponList: "Coupon List",

    NoteRateTitle: "Notes and Ratings",

    ProfileTitle: "My Profile",

    ContractDate: "Contract Date",
    OrderNumber: "Order Number",
    Send: "Send",
    Notes: "Notes",
    Service: "Service",
    Representative: "Representative",
    ConfermPassword: "Confirm Password",
    Save: "Save",
    Balance: "Balance",

    Profile: "Profile",
    email: "Email",
    representative: "Representative Name",
    representativeNo: "Representative Phone Number",
    CustomerService: "Customer Service",
    TermsAndConditions: "Terms and Conditions",
    
  // Login options
  RememberMe: "Remember me",
    AboutUsTitle: "About Us",
    AboutUs:
      "Guthmi is a distinguished name in diversified fabrics and textiles, recognized as the 4th largest fabric company listed for wholesale outside North America (according to Fabrics & Furnishing International). We represent a perfect blend of quality, innovation, and affordability.\n\nWe are dedicated to enhancing the lives of our customers across various sectors, including retail, palaces, furniture factories, hotels, and interior design. This commitment is realized through our meticulously curated selection of premium fabrics, textiles, and exquisite accessories, along with our customization options.\n\nOur portfolio includes outdoor and blackout curtains as well as products for children. Each item is chosen with a focus on quality and excellence, catering to a wide range of styles and preferences, from premium to value categories.\n\nOur company offers a broad spectrum of fabrics, ranging from timeless classics to cutting-edge contemporary designs, and from understated simplicity to high fashion. In our commitment to innovation, we also provide specialty-treated fabrics, such as Easy Clean, Child & Pet Friendly, Fire Retardant, Water Repellent, Spill & Stain Resistant, Durable, Odor Resistant, and Anti-bacterial options, adding an extra layer of value to our offerings.\n\nOur app is designed to make ordering easier than ever. With just a click, you can browse at your own pace, chat with us, ask questions, and place your order. We are constantly striving to improve and provide you with the best service possible.\n\nEnjoy the journey with Guthmi.",
  },
  tr: {
    More: "Daha Fazla",
    LanguageTitle: "Dil",
    Language: "Türkçe",
    AppColor: "Uygulama Rengi",
    Logout: "Çıkış Yap",
    loginAccount: "Hesaba Giriş",
    loginPara: "Kumaşlar Dünyasını Keşfedin",
    ClientCode: "Müşteri Kodu",
    MobileNumber: "Cep Telefonu Numarası",
    Password: "Şifre",
    Login: "Giriş Yap",
    Loading: "Yükleniyor",
    ErrorClientCode: "Lütfen 9 veya 10 basamaklı geçerli bir numara girin.",
    ErrorMobileNumber: "Lütfen geçerli bir 10 haneli mobil numara girin.",
    ErrorPassword: "Lütfen en az 10 karakterden oluşan bir şifre girin.",

    // Notification translations
    enableNotifications: "Bildirimleri Etkinleştir",
    enableNotificationsDesc: "En son teklifler ve siparişler hakkında güncel kalmanız için uygulamanın bildirim göndermesine izin verin",
    allow: "İzin Ver",
    later: "Daha Sonra",
    notificationsEnabled: "Bildirimler Etkinleştirildi",
    notificationsEnabledDesc: "Artık yeni teklifler ve sipariş durumu hakkında bildirimler alacaksınız",
    testNotification: "Test Bildirimi",
    notificationTestSent: "Test bildirimi gönderildi",
    notificationPermissionDenied: "Bildirim izni reddedildi",
    notificationPermissionDefault: "Bildirim izni henüz istenmedi",
    notificationPermissionGranted: "Bildirim izni verildi",

    verifyPhone: "Telefonu Doğrula",
    verifyText: "Kod gönderildi",
    verifyResent: "Kodu almadınız mı?",
    verifyResentbtn: "Tekrar iste",
    Verify: "Doğrula",

    HomeTitle: "Ana Sayfa",
    Morning: "Günaydın",
    Hello: "Merhaba",
    daysOfWeek: [
      "Pazar",
      "Pazartesi",
      "Salı",
      "Çarşamba",
      "Perşembe",
      "Cuma",
      "Cumartesi",
    ],
    Goles: "Hedefler",
    intarget: "Satın Aldıklarım",
    outtargit: "YYüksek İndirimli Satın Aldıklarım",
    latePay: "Geç Ödemeler",
    Currency: "Riyal",
  CurrencyKuwaitShort: "KWD",
  CurrencyQatarShort: "QAR",
  CurrencyBahrainShort: "BHD",
  CurrencyLebanonShort: "USD",
  CurrencyYemenShort: "YER",
  CurrencyOmanShort: "OMR",
  CurrencyJordanShort: "JOD",
    Invoices: "Faturalar",
    LATEPRO: "Gecikmiş Teslimat Sözleşmeleri",
    Returns: "İadeler",

    OrderTitle: "Sipariş",
    MyOrderTitle: "Siparişlerim",
    SearchTitle: "Sözleşme / Fatura Numarası",
    Search: "Ara",
    LastOrders: "Son 10 Sipariş",
    ContractNumber: "Sözleşme Numarası",
    OrderDate: "Sipariş Tarihi",
    Tracking: "Takip",
    Ordered: "Sipariş Edildi",
    Prepared: "Hazırlandı",
    Shipped: "Gönderildi",
    Delivered: "Teslim Edildi",
    DeliveredDate: "Teslim Tarihi",
    orderItems: "Sipariş Detayı",
    No: "No.",
    CancelOrder: "Siparişi iptal etmek için çağrı merkezi ile iletişime geçin.",

    ProductTitle: "Ürünler",
    Product: "Ürün",
    Catalog: "Katalog",
    QRcode: "QR Kodu",
    ProductCode: "Ürün Kodu",
    CatalogNumber: "Katalog Numarası",
    Serial: "Seri",
    Quantity: "Miktar",
    Type: "Tür",
    Upholstery: "Döşeme",
    Curtains: "Perdeler",
    Cushion: "Yastık",
    AllWhs: "Tüm depolarda ara",
    State: "Durum",
    OnePiece: "Bir Parça",
    SeveralPiece: "Birkaç Parça",
    SmallerPiece: "Daha Küçük Parça Boyutu",
    Wasalat: "Talep makbuzlar içerebilir.",
    otherItem: "Koleksiyondaki diğer ürünler",

    Thank: "Teşekkür ederim!",
    ThankBady: "Guthmi'yi seçtiğiniz için teşekkür ederiz, Sipariş numarası",

    Checkout: "Ödeme",
    PaymentDetails: "Ödeme Detayları",
    PaymentMethod: "Ödeme Yöntemi",
    Cash: "Nakit",
    DebitCredit: "Banka/Kredi Kartı",
    OrderSummary: "Sipariş Özeti",
    DeliveryFees: "Teslimat Ücretleri",

    SizeOfEach: "Her Parçanın Boyutu",
    Price: "KDV Dahil Fiyat:",
    Composition: "Kompozisyon:",
    Width: "Genişlik:",
    Weight: "Ağırlık:",
    PatternRepeat: "Desen Tekrarı:",
    Country: "Ülke:",
    Repository: "Depo:",
    addToCart: "Sepete Ekle",
    ItemNotFound: "Ürün bulunamadı",

    CartTitle: "Alışveriş Sepeti",
    total: "Toplam (KDV Dahil):",
    ConfirmOrder: "Siparişi Onayla",
    NoCartItem: "Sepette ürün yok",

  OfferTitle: "Teklifler",
  ShowMore: "Daha Fazla Göster",
  ValidTill: "Son Kullanma Tarihi :",
  VideoTagNotSupported: "Tarayıcınız video etiketini desteklemiyor.",
  UnknownOfferType: "Bilinmeyen Teklif Türü",
  OfferAlt: "Teklif",

    Coupon: "Kupon",
    coupNo: "Kupon Numarası",
    ExpiryDate: "Son Kullanma Tarihi",
    invoiceValue: "Fatura değerinden",

    SearchCatalogTitle: "Katalog Numarası",
    Catalogs: "Kataloglar",
    CatalogNo: "Katalog No.",

    CouponList: "Kupon Listesi",

    NoteRateTitle: "Notlar ve Puanlar",

    ProfileTitle: "Profilim",

    ContractDate: "Sözleşme Tarihi",
    OrderNumber: "Sipariş Numarası",
    Send: "Gönder",
    Notes: "Notlar",
    Service: "Hizmet",
    Representative: "Temsilci",
    ConfermPassword: "Şifreyi Onayla",
    Save: "Kaydet",
    Balance: "Bakiye",

    Profile: "Profil",
    email: "E-posta",
    representative: "Temsilci adı",
    representativeNo: "Temsilci telefon numarası",
    CustomerService: "Müşteri Hizmetleri",
    TermsAndConditions: "Şartlar ve Koşullar",
    
  // Login options
  RememberMe: "Beni hatırla",
    AboutUsTitle: "Hakkımızda",
    AboutUs:
      "Guthmi, çeşitli kumaşlar ve tekstiller alanında tanınmış bir isimdir ve Kuzey Amerika dışındaki toptan satışlarda 4. en büyük kumaş şirketi olarak bilinir (Fabrics & Furnishing International'a göre). Kalite, yenilik ve uygun fiyatın mükemmel bir birleşimini temsil ediyoruz.\n\nPerakende, saraylar, mobilya fabrikaları, oteller ve iç mekan tasarımı gibi çeşitli sektörlerde müşterilerimizin hayatlarını iyileştirmeye adadık. Bu taahhüt, özenle seçilmiş premium kumaşlarımız, tekstillerimiz ve zarif aksesuarlarımız ile ve ayrıca özelleştirme seçeneklerimizle gerçekleşir.\n\nPortföyümüz ayrıca dış mekan ve karartma perdeleri ile çocuk ürünlerini de içerir. Her bir ürün, kalite ve mükemmeliyete odaklanarak, premiumdan değer kategorilerine kadar geniş bir stil ve tercihlere hitap edecek şekilde titizlikle seçilmiştir.\n\nŞirketimiz, zamansız klasiklerden modern çağdaş tasarımlara kadar ve basitlikten yüksek modaya kadar geniş bir kumaş yelpazesi sunmaktadır. Yenilikçilik ruhumuzla, ayrıca Kolay Temizleme, Çocuk & Evcil Hayvan Dostu, Alev Geciktirici, Su Geçirmez, Sıçrama & Lekelere Karşı Dayanıklı, Dayanıklı, Kokuya Karşı Dirençli ve Antibakteriyel seçenekler sunan özel işlenmiş kumaşlar da sağlıyoruz. Bu, tekliflerimize bir ekstra değer katmaktadır.\n\nUygulamamız, sipariş vermeyi her zamankinden daha kolay hale getirmek için tasarlanmıştır. Tek bir tıklama ile, kendi hızınızda göz atabilir, bizimle sohbet edebilir, sorular sorabilir ve siparişinizi verebilirsiniz. Hizmetimizi sürekli olarak geliştirmeye ve size en iyi hizmeti sunmaya çalışıyoruz.\n\nGuthmi ile yolculuğun tadını çıkarın.",
  },
  urdu: {
    More: "مزید",
    LanguageTitle: "زبان",
    Language: "اردو",
    AppColor: "ایپ کا رنگ",
    Logout: "لاگ آوٹ",
    loginAccount: "اکاؤنٹ میں لاگ ان کریں",
    loginPara: "کپڑوں کی دنیا دریافت کریں",
    ClientCode: "کسٹمر کوڈ",
    MobileNumber: "موبائل نمبر",
    Password: "پاس ورڈ",
    Login: "لاگ ان",
    Loading: "لوڈ ہو رہا ہے",
    ErrorClientCode: "براہ کرم 9 یا 10 ہندسوں پر مشتمل ایک درست نمبر درج کریں۔",
    ErrorMobileNumber: "براہ کرم 10 ہندسوں کا صحیح موبائل نمبر درج کریں۔",
    ErrorPassword: "براہ کرم کم از کم 10 حروف پر مشتمل ایک پاس ورڈ درج کریں۔",

    verifyPhone: "فون کی تصدیق کریں",
    verifyText: "کوڈ بھیجا گیا ہے",
    verifyResent: "کوڈ موصول نہیں ہوا؟",
    verifyResentbtn: "دوبارہ درخواست کریں",
    Verify: "تصدیق کریں",

    HomeTitle: "ہوم",
    Morning: "صبح بخیر",
    Hello: "ہیلو",
    daysOfWeek: ["اتوار", "سوموار", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"],
    Goles: "مقاصد",
    intarget: "میری خریداری",
    outtargit: " میری خریداری ایک اعلی رعایت پر ہے",
    latePay: "دیر سے ادا کریں",
    Currency: " ریال",
  CurrencyKuwaitShort: "KWD",
  CurrencyQatarShort: "QAR",
  CurrencyBahrainShort: "BHD",
  CurrencyLebanonShort: "USD",
  CurrencyYemenShort: "YER",
  CurrencyOmanShort: "OMR",
  CurrencyJordanShort: "JOD",
    Invoices: "انوائسز",
    LATEPRO: "دیر سے پیمانے",
    Returns: "واپسیاں",

    OrderTitle: "آرڈر",
    MyOrderTitle: "میرے آرڈر",
    SearchTitle: "کنٹریکٹ / انوائس نمبر",
    Search: "تلاش",
    LastOrders: "آخری 10 آرڈر",
    ContractNumber: "کنٹریکٹ نمبر",
    OrderDate: "آرڈر تاریخ",
    Tracking: "ٹریکنگ",
    Ordered: "آرڈر کیا گیا",
    Prepared: "تیار کیا گیا",
    Shipped: "بھیجا گیا",
    Delivered: "سپلائی ہو گئی",
    DeliveredDate: "تسلیم کی تاریخ",
    orderItems: "آرڈر کی تفصیلات",
    No: "نمبر",
    CancelOrder: "آرڈر منسوخ کرنے کے لیے کال سینٹر سے رابطہ کریں۔",

    ProductTitle: "پروڈکٹ",
    Product: "پروڈکٹ",
    Catalog: "کیٹالوگ",
    QRcode: "کیو آر کوڈ",
    ProductCode: "پروڈکٹ کوڈ",
    CatalogNumber: "کیٹالوگ نمبر",
    Serial: "سیریل",
    Quantity: "مقدار",
    Type: "قسم",
    Upholstery: "فرنیچر کی مرمت",
    Curtains: "پردے",
    Cushion: "تکیہ",
    AllWhs: "تمام گوداموں میں تلاش کریں",
    State: "حالت",
    OnePiece: "ایک ٹکڑا",
    SeveralPiece: "کئی ٹکڑے",
    SmallerPiece: "چھوٹا ٹکڑا سائز",
    Wasalat: "درخواست میں رسیدیں شامل ہو سکتی ہیں۔",
    otherItem: "مجموعے کی دیگر مصنوعات",

    Thank: "شکریہ!",
    ThankBady: "گتھمی کو منتخب کرنے کا شکریہ، آرڈر نمبر",

    Checkout: "چیک آؤٹ",
    PaymentDetails: "ادائیگی کی تفصیلات",
    PaymentMethod: "ادائیگی کا طریقہ",
    Cash: "نقد",
    DebitCredit: "ڈیبٹ/کریڈٹ کارڈ",
    OrderSummary: "آرڈر کا خلاصہ",
    DeliveryFees: "ترسیل کی فیس",

    SizeOfEach: "ہر ٹکڑے کا سائز",
    Price: "قیمت (ضمنی ٹیکس کے ساتھ):",
    Composition: "ترکیب:",
    Width: "چوڑائی:",
    Weight: "وزن:",
    PatternRepeat: "نمونہ دہرانا:",
    Country: "ملک:",
    Repository: "ریپازیٹری:",
    addToCart: "کارٹ میں شامل کریں",
    ItemNotFound: "آئٹم دستیاب نہیں",

    CartTitle: "کارٹ",
    total: "کل (ضمنی ٹیکس کے ساتھ):",
    ConfirmOrder: "آرڈر کی تصدیق کریں",
    NoCartItem: "کوئی کارٹ آئٹم نہیں ہے",

  OfferTitle: "پیشکشیں",
  ShowMore: "مزید دکھائیں",
  ValidTill: "تک مؤثر:",
  VideoTagNotSupported: "آپ کا براؤزر ویڈیو ٹیگ کی حمایت نہیں کرتا۔",
  UnknownOfferType: "نامعلوم آفر کی قسم",
  OfferAlt: "آفر",

    Coupon: "کوپن",
    coupNo: "کوپن نمبر",
    ExpiryDate: "ختم ہونے کی تاریخ",
    invoiceValue: "بل کی قیمت سے",

    SearchCatalogTitle: "کیٹلاگ نمبر",
    Catalogs: "کیٹلاگ",
    CatalogNo: "کیٹلاگ نمبر:",

    CouponList: "کوپن لسٹ",

    NoteRateTitle: "نوٹس اور ریٹنگ",

    ProfileTitle: "پروفائل",

    ContractDate: "کنٹریکٹ کی تاریخ",
    OrderNumber: "آرڈر نمبر",
    Send: "بھیجیں",
    Notes: "نوٹس",
    Service: "خدمت",
    Representative: "نمائندہ",
    ConfermPassword: "پاس ورڈ کی تصدیق کریں",
    Save: "محفوظ کریں",
    Balance: "بقیہ",

    Profile: "پروفائل",
    email: "ای میل",
    representative: "نمائندہ کا نام",
    representativeNo: "نمائندہ کا فون نمبر",
    CustomerService: "خدمتِ اہلِ تمیز",
    TermsAndConditions: "شرائط و ضوابط",
    
  // Login options
  RememberMe: "مجھے یاد رکھیں",
    AboutUsTitle: "ہمارے بارے میں",
    AboutUs:
      "Guthmi ایک ممتاز نام ہے جو متنوع کپڑوں اور ٹیکسٹائل میں معروف ہے اور شمالی امریکہ کے باہر تھوک فروشی کے لیے فہرست میں چوتھی سب سے بڑی کپڑا کمپنی کے طور پر جانا جاتا ہے (Fabrics & Furnishing International کے مطابق)۔ ہم معیار، جدت، اور معقولیت کا بہترین امتزاج پیش کرتے ہیں۔\n\nہم مختلف شعبوں میں اپنے صارفین کی زندگیوں کو بہتر بنانے کے لیے پرعزم ہیں، بشمول ریٹیل، محل، فرنیچر کے کارخانے، ہوٹل، اور اندرونی ڈیزائن۔ یہ عزم ہمارے اعلیٰ منتخب کردہ کپڑوں، ٹیکسٹائل، اور شاندار لوازمات کے ساتھ ساتھ حسب ضرورت اختیارات کے ذریعے حاصل ہوتا ہے۔\n\nہماری پورٹ فولیو میں بیرونی اور بلیک آؤٹ پردے اور بچوں کی مصنوعات بھی شامل ہیں۔ ہر چیز کو معیار اور برتری پر توجہ دیتے ہوئے منتخب کیا گیا ہے، جو مختلف طرزوں اور ذوق کی ضروریات کو پورا کرتی ہے، پریمیم سے لے کر ویلیو کیٹگریز تک۔\n\nہماری کمپنی وسیع پیمانے پر کپڑے پیش کرتی ہے، جو کلاسیکی سے لے کر جدید ترین ڈیزائنز تک، اور سادہ سے لے کر سب سے اونچے فیشن تک کی حد تک ہیں۔ ہم جدت کی روح میں، خصوصی طور پر علاج شدہ کپڑے بھی فراہم کرتے ہیں، جیسے کہ آسان صفائی، بچوں اور پالتو جانوروں کے دوستانہ، آگ کی مزاحمت کرنے والے، پانی کے خلاف مزاحم، داغ اور گراوٹ کے خلاف مزاحم، پائیدار، بدبو کے خلاف مزاحم، اور اینٹی بیکٹیریا اختیارات، جو ہماری پیشکشوں کو اضافی قدر فراہم کرتے ہیں۔\n\nہمارا ایپ آپ کے لیے آرڈر دینا پہلے سے کہیں زیادہ آسان بنانے کے لیے تیار کیا گیا ہے۔ صرف ایک کلک کے ساتھ، آپ اپنے آرام کے مطابق براؤز کر سکتے ہیں، ہم سے بات چیت کر سکتے ہیں، سوالات پوچھ سکتے ہیں، اور اپنے آرڈر کو مکمل کر سکتے ہیں۔ ہم ہمیشہ اپنی خدمات کو بہتر بنانے اور آپ کو بہترین سروس فراہم کرنے کی کوشش کرتے ہیں۔\n\nGuthmi کے ساتھ اپنے سفر کا لطف اٹھائیں۔",
  },
  hi: {
    More: "अधिक",
    LanguageTitle: "भाषा",
    Language: "हिंदी",
    AppColor: "ऐप कलर",
    Logout: "लॉग आउट",
    loginAccount: "खाते में लॉगिन करें",
    loginPara: "कपड़ों की दुनिया को जानिए",
    ClientCode: "ग्राहक कोड",
    MobileNumber: "मोबाइल नंबर",
    Password: "पासवर्ड",
    Login: "लॉगिन",
    Loading: "लोड हो रहा है",
    ErrorClientCode: "कृपया 9 या 10 अंकों की एक मान्य संख्या दर्ज करें।",
    ErrorMobileNumber: "कृपया एक वैध 10-अंकीय मोबाइल नंबर दर्ज करें।",
    ErrorPassword: "कृपया कम से कम 10 अक्षरों का पासवर्ड दर्ज करें।",

    verifyPhone: "फ़ोन सत्यापित करें",
    verifyText: "कोड भेजा गया है",
    verifyResent: "कोड नहीं मिला?",
    verifyResentbtn: "फिर से अनुरोध करें",
    Verify: "सत्यापित करें",

    HomeTitle: "होम",
    Morning: "सुप्रभात",
    Hello: "नमस्ते",
    daysOfWeek: [
      "रविवार",
      "सोमवार",
      "मंगलवार",
      "बुधवार",
      "गुरुवार",
      "शुक्रवार",
      "शनिवार",
    ],
    Goles: "लक्ष्य",
    intarget: "बिक्री",
    outtargit: "उच्च डिस्काउंट बिक्री",
    latePay: "विलंबित भुगतान",
    Currency: "रियाल",
  CurrencyKuwaitShort: "KWD",
  CurrencyQatarShort: "QAR",
  CurrencyBahrainShort: "BHD",
  CurrencyLebanonShort: "USD",
  CurrencyYemenShort: "YER",
  CurrencyOmanShort: "OMR",
  CurrencyJordanShort: "JOD",
    Invoices: "चालान",
    LATEPRO: "विलंबित वितरण संविदाएँ",
    Returns: "वापसी",

    OrderTitle: "आदेश",
    MyOrderTitle: "मेरे ऑर्डर",
    SearchTitle: "संविदा / चालान नंबर",
    Search: "खोज",
    LastOrders: "पिछले 10 ऑर्डर",
    ContractNumber: "संविदा नंबर",
    OrderDate: "आदेश दिनांक",
    Tracking: "ट्रैकिंग",
    Ordered: "आदेश दिया गया",
    Prepared: "तैयार",
    Shipped: "भेज दिया गया",
    Delivered: "पहुँचाया गया",
    DeliveredDate: "पहुँचाने की तारीख",
    orderItems: "आदेश विवरण",
    No: "संख्या ",
    CancelOrder: "ऑर्डर रद्द करने के लिए कॉल सेंटर से संपर्क करें।",

    ProductTitle: "उत्पाद",
    Product: "उत्पाद",
    Catalog: "कैटलॉग",
    QRcode: "क्यूआर कोड",
    ProductCode: "उत्पाद कोड",
    CatalogNumber: "कैटलॉग नंबर",
    Serial: "सीरियल",
    Quantity: "मात्रा",
    Type: "प्रकार",
    Upholstery: "उपहार",
    Curtains: "पर्दे",
    Cushion: "कुशन",
    AllWhs: "सभी गोदामों से खोजें",
    State: "राज्य",
    OnePiece: "एक टुकड़ा",
    SeveralPiece: "कई टुकड़े",
    SmallerPiece: "छोटे टुकड़े का आकार",
    Wasalat: "आवेदन में रसीदें शामिल हो सकती हैं।",
    otherItem: "- संग्रह की अन्य उत्पाद",

    Thank: "धन्यवाद!",
    ThankBady: "गुथमी को चुनने के लिए धन्यवाद, ऑर्डर नंबर",

    Checkout: "चेकआउट",
    PaymentDetails: "भुगतान विवरण",
    PaymentMethod: "भुगतान विधि",
    Cash: "नकद",
    DebitCredit: "डेबिट/क्रेडिट कार्ड",
    OrderSummary: "ऑर्डर सारांश",
    DeliveryFees: "डिलीवरी शुल्क",

    SizeOfEach: "प्रति टुकड़े का आकार",
    Price: "मूल्य (वैल्यू एडेड टैक्स के साथ):",
    Composition: "संरचना:",
    Width: "चौड़ाई:",
    Weight: "वजन:",
    PatternRepeat: "पैटर्न दोहराना:",
    Country: "देश:",
    Repository: "संग्रहालय:",
    addToCart: "कार्ट में डालें",
    ItemNotFound: "आइटम उपलब्ध नहीं है",

    CartTitle: "कार्ट",
    total: "कुल (वैल्यू एडेड टैक्स के साथ):",
    ConfirmOrder: "ऑर्डर की पुष्टि करें",
    NoCartItem: "कोई कार्ट आइटम नहीं",

  OfferTitle: "ऑफ़र्स",
  ShowMore: "और दिखाएं",
  ValidTill: "तक मान्य:",
  VideoTagNotSupported: "आपका ब्राउज़र वीडियो टैग को सपोर्ट नहीं करता।",
  UnknownOfferType: "अज्ञात ऑफर प्रकार",
  OfferAlt: "ऑफर",

    Coupon: "कूपन",
    coupNo: "कूपन नंबर",
    ExpiryDate: "समाप्ति तिथि",
    invoiceValue: "चालान की राशि से",

    SearchCatalogTitle: "कैटलॉग नंब",
    Catalogs: "सूचियाँ",
    CatalogNo: "कैटलॉग संख्या:",

    CouponList: "कूपन सूची",

    NoteRateTitle: "नोट्स और रेटिंग्स",

    ProfileTitle: "मेरी प्रोफ़ाइल",

    ContractDate: "संविदा दिनांक",
    OrderNumber: "ऑर्डर नंबर",
    Send: "भेजें",
    Notes: "टिप्पणियाँ",
    Service: "सेवा",
    Representative: "प्रतिनिधि",
    ConfermPassword: "पासवर्ड पुष्टि करें",
    Save: "सहेजें",
    Balance: "शेष",

    Profile: "प्रोफ़ाइल",
    email: "ईमेल",
    representative: "प्रतिनिधि का नाम",
    representativeNo: "प्रतिनिधि का फोन नंबर",
    CustomerService: "ग्राहक सेवा",
    TermsAndConditions: "नियम और शर्तें",
    
  // Login options
  RememberMe: "मुझे याद रखें",
    AboutUsTitle: "हमारे बारे में",
    AboutUs:
      "Guthmi एक प्रमुख नाम है जो विविध प्रकार के कपड़े और वस्त्रों में प्रसिद्ध है और उत्तरी अमेरिका के बाहर थोक बिक्री के लिए चौथी सबसे बड़ी कपड़ा कंपनी के रूप में सूचीबद्ध है (Fabrics & Furnishing International के अनुसार)। हम गुणवत्ता, नवाचार और सस्ती कीमतों का एक आदर्श मिश्रण प्रस्तुत करते हैं।\n\nहम अपने ग्राहकों के जीवन को विभिन्न क्षेत्रों में बेहतर बनाने के लिए प्रतिबद्ध हैं, जैसे कि खुदरा, महल, फर्नीचर कारखाने, होटल, और आंतरिक डिज़ाइन। यह प्रतिबद्धता हमारे उत्तम चयनित कपड़ों, वस्त्रों और शानदार एक्सेसरीज़ के साथ-साथ कस्टमाइजेशन विकल्पों के माध्यम से प्राप्त होती है।\n\nहमारी पोर्टफोलियो में बाहरी और ब्लैकआउट पर्दे और बच्चों के उत्पाद भी शामिल हैं। प्रत्येक उत्पाद को गुणवत्ता और उत्कृष्टता पर ध्यान केंद्रित करते हुए चुना गया है, जो प्रीमियम से लेकर मूल्य श्रेणियों तक विभिन्न शैलियों और प्राथमिकताओं को पूरा करता है।\n\nहमारी कंपनी एक व्यापक श्रृंखला के कपड़े पेश करती है, जो कालातीत क्लासिक्स से लेकर अत्याधुनिक समकालीन डिज़ाइन तक, और साधारण से लेकर उच्चतम फैशन तक की सीमा में हैं। नवाचार की भावना में, हम विशेष रूप से उपचारित कपड़े भी प्रदान करते हैं, जैसे कि आसान सफाई, बच्चों और पालतू जानवरों के अनुकूल, आग प्रतिरोधी, पानी प्रतिरोधी, दाग और स्पिल प्रतिरोधी, मजबूत, गंध प्रतिरोधी और एंटी-बैक्टीरियल विकल्प, जो हमारी पेशकशों में अतिरिक्त मूल्य जोड़ते हैं।\n\nहमारा ऐप ऑर्डर देने को पहले से कहीं अधिक आसान बनाने के लिए डिज़ाइन किया गया है। बस एक क्लिक से, आप अपनी सुविधा से ब्राउज़ कर सकते हैं, हमसे चैट कर सकते हैं, सवाल पूछ सकते हैं, और अपना ऑर्डर दे सकते हैं। हम हमेशा अपनी सेवाओं को सुधारने और आपको सबसे अच्छी सेवा प्रदान करने की कोशिश करते हैं।\n\nGuthmi के साथ अपने सफर का आनंद लें।",
  },
  my: {
    More: "နောက်ထပ်",
    LanguageTitle: "ဘာသာစကား",
    Language: "မြန်မာ",
    AppColor: "အပလီကေးရှင်းအရောင်",
    Logout: "ထွက်ရန်",
    loginAccount: "အကောင့်ဝင်ရန်",
    loginPara: "ဖက်ရှင်ခေတ်သစ်ကို ရှာဖွေပါ",
    ClientCode: "ဖောက်သည်ကုဒ်",
    MobileNumber: "ဖုန်းနံပါတ်",
    Password: "စကားဝှက်",
    Login: "လော့ဂ်အင်",
    Loading: "ဖတ်ယူနေသည်...",
    ErrorClientCode:
      "ကျေးဇူးပြု၍ ငါးလုံး သို့မဟုတ် ဆယ်လုံးပါဝင်သော မှန်ကန်သော နံပါတ်တစ်ခု ထည့်ပါ။",
    ErrorMobileNumber:
      "ကျေးဇူးပြုပြီး မှန်ကန်သော 10 လုံးပါသော ဖုန်းနံပါတ်ကို ထည့်ပါ။",
    ErrorPassword:
      "အနည်းဆုံး စာလုံး 10 လုံးပါသော စကားဝှက်ကို ထည့်ရန်လိုအပ်သည်။",

    verifyPhone: "ဖုန်းကိုအတည်ပြုပါ",
    verifyText: "ကုဒ်ကိုပို့ပြီးပါပြီ",
    verifyResent: "ကုဒ်မရသေးဘူးလား?",
    verifyResentbtn: "ထပ်မံတောင်းဆိုပါ",
    Verify: "အတည်ပြုပါ",

    HomeTitle: "ပင်မစာမျက်နှာ",
    Morning: "မင်္ဂလာနံနက်ခင်းပါ",
    Hello: "ဟယ်လို",
    daysOfWeek: [
      "တနင်္ဂနွေ",
      "တနင်္လာ",
      "အင်္ဂါ",
      "ဗုဒ္ဓဟူး",
      "ကြာသပတေး",
      "သောကြာ",
      "စနေ",
    ],
    Goles: "သင်၏ရည်ရွယ်ချက်",
    intarget: "ငွေပေးချေမှုများ",
    outtargit: "လျှော့စျေးဖြင့်အော်ဒါများ",
    latePay: "အကြွေးရှင်းမှုနောက်ကျမှုများ",
    Currency: "ရီယော်",
  CurrencyKuwaitShort: "KWD",
  CurrencyQatarShort: "QAR",
  CurrencyBahrainShort: "BHD",
  CurrencyLebanonShort: "USD",
  CurrencyYemenShort: "YER",
  CurrencyOmanShort: "OMR",
  CurrencyJordanShort: "JOD",
    Invoices: "ဘောင်ချာများ",
    LATEPRO: "နောက်ကျသွင်းရောက်မှုများ",
    Returns: "ပြန်အမ်းမှုများ",

    OrderTitle: "အော်ဒါ",
    MyOrderTitle: "ကျွန်ုပ်၏အော်ဒါများ",
    SearchTitle: "စာချုပ် / ဘောင်ချာနံပါတ်",
    Search: " ရှာဖွေရန် ",
    LastOrders: "နောက်ဆုံး ၁၀ ခုအော်ဒါများ",
    ContractNumber: "စာချုပ်နံပါတ်",
    OrderDate: "အော်ဒါအပ်သည့်နေ့",
    Tracking: "လိုက်နာမှု",
    Ordered: "အော်ဒါလက်ခံပြီး",
    Prepared: "ဖြတ်တောက်ပြီး",
    Shipped: "တင်ပို့ပြီး",
    Delivered: "ပေးအပ်ပြီး",
    DeliveredDate: "ပေးအပ်သည့်နေ့",
    orderItems: "အော်ဒါအသေးစိတ်",
    No: "နံပါတ်",
    CancelOrder: "အော်ဒါဖျက်ရန် ဖောက်သည်ဝန်ဆောင်မှုကို ဆက်သွယ်ပါ။",

    ProductTitle: "ထုတ်ကုန်များ",
    Product: "ထုတ်ကုန်",
    Catalog: "ကတ်တလောက်",
    QRcode: "QR ကုဒ်",
    ProductCode: "ထုတ်ကုန်ကုဒ်",
    CatalogNumber: "ကတ်တလောက်နံပါတ်",
    Serial: "အစဉ်နံပါတ်",
    Quantity: "အရေအတွက်",
    Type: "အမျိုးအစား",
    Upholstery: "ခုံဖုံးအဖုံး",
    Curtains: "ကတုတ်များ",
    Cushion: "ခင်မင်",
    AllWhs: "သိုလှောင်ရုံအားလုံးတွင် ရှာဖွေရန်",
    State: "အခြေအနေ",
    OnePiece: "တစ်ချပ်တည်း",
    SeveralPiece: "ချပ်အများအပြား",
    SmallerPiece: "အနည်းဆုံးအရွယ်",

    SizeOfEach: "တစ်ချပ်စီအရွယ်အစား",
    Price: "စျေးနှုန်း (အခွန်ပါ):",
    Composition: "ပုစွန်ချဉ်:",
    Width: "အကျယ်:",
    Weight: "အလေးချိန်:",
    PatternRepeat: "နမူနာထပ်မှု:",
    Country: "နိုင်ငံ:",
    Repository: "သိုလှောင်ရုံ:",
    addToCart: "စျေးခြင်းထဲသို့ထည့်ရန်",
    ItemNotFound: "ထုတ်ကုန်ရှာမတွေ့ပါ",
    Wasalat: "အော်ဒါတွင် တစ်စုံတစ်ခုရှိနိုင်သည်",
    otherItem: "အခြားထုတ်ကုန်များ",

    Thank: "ကျေးဇူးတင်ပါတယ်!",
    ThankBady: "AlGuthmi ကို ရွေးချယ်မှုအတွက် ကျေးဇူးတင်ပါတယ်။ အော်ဒါနံပါတ်:",

    Checkout: "ငွေပေးချေမှု",
    PaymentDetails: "ငွေပေးချေမှုအသေးစိတ်",
    PaymentMethod: "ငွေပေးချေမှုနည်းလမ်း",
    Cash: "လက်ငင်း",
    DebitCredit: "ဘဏ်ကဒ် / ခရက်ဒစ်ကဒ်",
    OrderSummary: "အော်ဒါအကျဉ်းချုပ်",
    DeliveryFees: "ပို့ဆောင်ခ",

    CartTitle: "စျေးခြင်း",
    total: "စုစုပေါင်း (အခွန်ပါ):",
    ConfirmOrder: "အော်ဒါအတည်ပြုရန်",
    NoCartItem: "စျေးခြင်းတွင် ထည့်ထားသောပစ္စည်းမရှိပါ",

  OfferTitle: "ပရိုမိုးရှင်းများ",
  ShowMore: "နောက်ထပ်ကြည့်ရန်",
  ValidTill: "သက်တမ်းတိုင်:",
  VideoTagNotSupported: "သင်၏ဘရောက်ဇာသည် ဗီဒီယိုတဂ်ကို မထောက်ပံ့ပါ။",
  UnknownOfferType: "မသိသော ကမ်းလှမ်းမှု အမျိုးအစား",
  OfferAlt: "ကမ်းလှမ်းချက်",

    Coupon: "ကူပွန်",
    coupNo: "ကူပွန်နံပါတ်",
    ExpiryDate: "သက်တမ်းကုန်ဆုံးရက်",
    invoiceValue: "ဘောင်ချာတန်ဖိုးမှ",

    SearchCatalogTitle: "ကတ်တလောက်နံပါတ်",
    Catalogs: "ကတ်တလောက်များ",
    CatalogNo: "ကတ်တလောက်နံပါတ်:",

    CouponList: "ကူပွန်စာရင်း",

    NoteRateTitle: "မှတ်ချက်နှင့်အဆင့်သတ်မှတ်မှု",

    ProfileTitle: "ကိုယ်ရေးအချက်အလက်",

    ContractDate: "စာချုပ်ရက်စွဲ",
    OrderNumber: "အော်ဒါနံပါတ်",
    Send: "ပေးပို့ရန်",
    Notes: "မှတ်ချက်များ",
    Service: "ဝန်ဆောင်မှု",
    Representative: "ကိုယ်စားလှယ်",
    ConfermPassword: "စကားဝှက်အတည်ပြုပါ",
    Save: "သိမ်းဆည်းပါ",
    Balance: "လက်ကျန်ငွေ",

    Profile: "ကိုယ်ရေးအချက်အလက်",
    email: "အီးမေးလ်",
    representative: "ကိုယ်စားလှယ်အမည်",
    representativeNo: "ကိုယ်စားလှယ်ဖုန်းနံပါတ်",
    CustomerService: "ဖောက်သည်ဝန်ဆောင်မှု",
    TermsAndConditions: "စည်းကမ်းသတ်မှတ်ချက်များ",
    
  // Login options
  RememberMe: "မှတ်မိနေစေပါ",
    AboutUsTitle: "ကျွန်ုပ်တို့အကြောင်း",
    AboutUs:
      "ကျွန်ုပ်တို့သည် အမျိုးမျိုးသောအထည်နှင့်အနုမြူများ၏အမွေအနှစ်ဖြစ်ပြီး၊ အမေရိကန်မြောက်ပိုင်းပြင်ပရှိ လက်ကားအထည်ကုမ္ပဏီကြီးများအနက် စတုတ္ထမြောက်အဖြစ် (Fabrics & Furnishing International) မှ သတ်မှတ်ထားခြင်းခံရပါသည်။ ထို့အပြင် ကျွန်ုပ်တို့သည် အရည်အသွေး၊ ဖန်တီးမှုနှင့် သင့်တင့်သောစျေးနှုန်းများ၏ပေါင်းစပ်မှုကို ကိုယ်စားပြုပါသည်။\n\nကျွန်ုပ်တို့သည် လက်လီဆိုင်များ၊ နန်းတော်များ၊ ပရိဘောဂစက်ရုံများ၊ ဟိုတယ်များနှင့် အတွင်းပိုင်းဒီဇိုင်းလုပ်ငန်းများရှိ ဖောက်သည်များ၏ဘဝကို မြှင့်တင်ပေးရန်ကတိကဝတ်ပြုထားပါသည်။ ထူးခြားသောအထည်များ၊ အနုမြူများနှင့် လှပသောအဖုံးပစ္စည်းများကို ထောက်ပံ့ပေးခြင်းဖြင့်၊ ၎င်းတို့၏လိုအပ်ချက်များနှင့် ကိုက်ညီသောအထူးပရိုမိုးရှင်းများကိုလည်း ပေးဆောင်ပါသည်။\n\nဒီဇိုင်းနှင့်ဖန်တီးမှုသည် ကျွန်ုပ်တို့၏လုပ်ငန်း၏အခြေခံဖြစ်ပြီး၊ ၎င်းတို့သည် ကျွန်ုပ်တို့၏သက်တမ်းတစ်လျှောက်လုံးတွင် တီထွင်မှုနှင့် ထူးခြားမှု၏အရင်းအမြစ်ဖြစ်သည်။\n\nကျွန်ုပ်တို့၏စုစည်းမှုတွင် ပြင်ပကပ်ခြင်းအထည်များ၊ မီးမဝင်နိုင်သောအထည်များနှင့် ကလေးပစ္စည်းများပါဝင်ပြီး၊ အရည်အသွေး၊ ထူးခြားမှုနှင့် မတူညီသောဖက်ရှင်စတိုင်များအတွက် တုံ့ပြန်နိုင်မှုကို အထူးအလေးပေးပါသည်။\n\nကျွန်ုပ်တို့၏ကုမ္ပဏီသည် ရိုးရာဒီဇိုင်းများမှ စတင်ပြီး ခေတ်မီဒီဇိုင်းများအထိ အမျိုးမျိုးသောအထည်များကို ပံ့ပိုးပေးပါသည်။ ထို့အပြင်၊ လွယ်ကူစွာသန့်ရှင်းနိုင်သောအထည်များ၊ ကလေးများနှင့် အိမ်မွေးတိရစ္ဆာန်များအတွက် သင့်လျော်သောအထည်များ၊ မီးမဝင်နိုင်သောအထည်များ၊ ရေစိုခံ၊ အစွန်းအထင်းခံနိုင်သောအထည်များနှင့် ဘက်တီးရီးယားကင်းရှင်းသောအထည်များကိုလည်း ထုတ်လုပ်ပေးပါသည်။\n\nကျွန်ုပ်တို့၏အက်ပ်သည် မှာယူမှုလုပ်ငန်းစဉ်ကို မည်သည့်အချိန်ထက်မဆို ပိုမိုလွယ်ကူအောင် ဖန်တီးထားပါသည်။ တစ်ချက်နှိပ်ခြင်းဖြင့် သင်သည် လိုအပ်သည့်အမြန်နှုန်းဖြင့် ရှာဖွေနိုင်ပြီး၊ ကျွန်ုပ်တို့နှင့် စကားပြောနိုင်ပြီး၊ မေးခွန်းများမေးနိုင်ပြီး၊ မှာယူမှုကို ပြုလုပ်နိုင်ပါသည်။\n\nကျွန်ုပ်တို့သည် သင်အတွက် အကောင်းဆုံးအတွေ့အကြုံကို ပေးနိုင်ရန်အတွက် မကြာခဏ ဝန်ဆောင်မှုများကို တိုးတက်အောင်လုပ်ဆောင်နေပါသည်။\n\nကျွန်ုပ်တို့နှင့်အတူ ခရီးစဉ်ကို စတင်ခံစားလိုက်ပါ။",
  },
};

// Function to get translated text based on language key and original text
export default function translateText(languageKey, originalText) {
  const languageTranslations = languageDictionary[languageKey] || {};
  return languageTranslations[originalText] || originalText;
}
